import { ref } from "vue";

export const FETCHING = "FETCHING";
export const READY = "READY";
export const UPDATING = "UPDATING";
export const EDIT = "EDIT";
export const ERROR = "ERROR";

type FetchingState = { type: typeof FETCHING };
type ReadyState = { type: typeof READY };
type UpdatingState = {
  type: typeof UPDATING;
  isAuto: boolean;
  isToJunk: boolean;
};
type EditState = { type: typeof EDIT; isAuto: boolean; isToJunk: boolean };
type ErrorState = { type: typeof ERROR };

type State =
  FetchingState | ReadyState | UpdatingState | EditState | ErrorState;

export const useRemediationSettingsState = () => {
  const state = ref<State>({ type: FETCHING });

  const isFetchingState = (state: State) => state.type === FETCHING;
  const isReadyState = (state: State) => state.type === READY;
  const isUpdatingState = (state: State) => state.type === UPDATING;
  const isEditState = (state: State) => state.type === EDIT;
  const isErrorState = (state: State) => state.type === ERROR;

  const setState = (newState: State) => (state.value = newState);

  return {
    state,
    isFetchingState,
    isReadyState,
    isUpdatingState,
    isEditState,
    isErrorState,
    setState,
  };
};

export default {};
